const map = {
	"./activity_event/view.html": 7921,
	"./activity_event_summon/view.html": 7207,
	"./arena_event/view.html": 8991,
	"./beginner_tournaments/view.html": 4208,
	"./champions_tournaments/view.html": 1062,
	"./dogs_tags_battle_pass/view.html": 91,
	"./gold_battle_pass/view.html": 7874,
	"./oil_battle_pass/view.html": 5820,
	"./summon_event/view.html": 6011,
	"./vip_battle_pass/view.html": 2533,
	"./visits/view.html": 7155
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9411;